import { Reveal } from "@/components/Reveal";

const REASONS = [
  { n: "01", title: "Professional Project Management", text: "One point of contact and clear oversight throughout your project." },
  { n: "02", title: "Trusted Contractors", text: "We work with reliable specialist trades to deliver each stage to a high standard." },
  { n: "03", title: "Quality First", text: "We focus on workmanship, materials and finishing — not simply getting the job finished." },
  { n: "04", title: "Clear Communication", text: "Straightforward communication, transparent expectations and regular project updates." },
  { n: "05", title: "Development Mindset", text: "We approach projects with both construction quality and property value in mind." },
];

export const WhyTyrell = () => (
  <section id="why-tyrell" data-testid="why-tyrell-section" className="relative bg-[#0A111E] py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mb-16">
        <div className="mb-6 flex items-center gap-4">
          <span className="h-px w-12 bg-gradient-to-r from-[#C5A059] to-transparent" />
          <span className="text-[11px] font-semibold uppercase tracking-[0.35em] text-[#C5A059]">The Difference</span>
        </div>
        <h2 className="font-serif text-3xl font-light uppercase leading-snug tracking-tight text-white sm:text-4xl lg:text-5xl">
          Why <span className="gold-text-gradient">Tyrell?</span>
        </h2>
      </Reveal>

      <div className="relative">
        <div className="absolute bottom-0 left-[27px] top-0 hidden w-px bg-gradient-to-b from-[#C5A059]/60 via-[#C5A059]/20 to-transparent lg:block" />
        <div className="space-y-2">
          {REASONS.map((r, i) => (
            <Reveal key={r.n} delay={i * 0.08}>
              <div
                data-testid={`why-reason-${r.n}`}
                className="group grid items-start gap-4 border-b border-[#C5A059]/10 py-9 transition-colors duration-500 hover:bg-[#C5A059]/[0.03] lg:grid-cols-[80px_1fr_2fr] lg:gap-10 lg:pl-2"
              >
                <span className="font-mono text-3xl font-light text-[#C5A059]/50 transition-colors duration-500 group-hover:text-[#C5A059] lg:text-4xl">
                  {r.n}
                </span>
                <h3 className="font-serif text-2xl font-medium uppercase tracking-wide text-white lg:text-3xl">
                  {r.title}
                </h3>
                <p className="max-w-xl text-base font-light leading-relaxed text-slate-400">{r.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
